export const Data = [
    {
        id: 'erik-huynh',
        title: 'About Me',
        image: 'https://github.com/E-Huynh/portfolio-gram/blob/master/src/assets/bio_pic.jpeg?raw=true',
        description: "Welcome to my Portfolio-gram!! My name is Erik and I'm a Full-Stack Web Developer that strives to learn and create web applications. I graduate from the University of Utah's 26-wk coding bootcamp, in May of 2020. Learn more about me and projects I've created by browsing my posts.",
        repo: 'https://github.com/E-Huynh',
        linkedin: 'https://www.linkedin.com/in/erik-huynh-228321196',
        link: '',
        tech: ['FullStack', 'WebDeveloper', 'UniversityOfUtah', 'React', 'Material-UI','FutureEmployee'],
        type: 'bio'
    },
    {
        id: 'trade-and-play',
        title: 'Trade and Play',
        image: 'https://github.com/E-Huynh/portfolio-gram/blob/master/src/assets/collection_ss.png?raw=true',
        description: 'Trade and play brings the excitement of sports card collecting onto the web. New collectible cards can be acquired from drafting from draft packs. Each card is uniquely decorated in team colors and displays an image and statistics of your favorite players. Draft packs contain a random assortment of players from a specific position. Make an account and collect them all!',
        repo: 'https://github.com/Arnette110/Trade-and-Play',
        link: 'https://trade-and-play.herokuapp.com/',
        tech: ['Material-UI', 'MongoDB', 'Express', 'AJAX/Axios', 'MERN'],
        type: 'project'
    },
    {
        id: 'stock-watcher',
        title: 'Stock Watcher',
        image: 'https://github.com/E-Huynh/portfolio-gram/blob/master/src/assets/stock-watcher.png?raw=true',
        description: 'Application allows users to search and view stock information. Users are able to organize and save stocks into watchlists.',
        repo: 'https://github.com/E-Huynh/stock-shares-viewer',
        link: 'https://young-everglades-16655.herokuapp.com/',
        tech: ['Bulma', 'MySQL', 'Sequelize', 'Express', 'AJAX/Axios', 'IEXcloud'],
        type: 'project'
    },
    {
        id: 'burger-wishlist',
        title: 'Burger Wishlist',
        image: 'https://github.com/E-Huynh/portfolio-gram/blob/master/src/assets/burger_wishlist.png?raw=true',
        description: 'Application that stores and displays users burger wishlist. The client displays and allows the user to interact with the database.',
        repo: 'https://github.com/E-Huynh/burger-wishlist',
        link: 'https://young-everglades-16655.herokuapp.com/',
        tech: ['ExpressHandlebars', 'MVC', 'MySQL', 'ORM'],
        type: 'project'
    },
    {
        id: 'employee-tracker',
        title: 'Employee Tracker',
        image: 'https://github.com/E-Huynh/portfolio-gram/blob/master/src/assets/employee_tracker.png?raw=true',
        description: 'CLI application that lets users store, add, delete, and update employee information from a mysql database.',
        repo: 'https://github.com/E-Huynh/employee_tracker',
        link: '',
        tech: ['Express', 'MySQL', 'Inquirer'],
        type: 'project'
    },

    {
        id: 'education',
        title: 'Education',
        image: 'https://github.com/E-Huynh/portfolio-gram/blob/master/src/assets/college.png?raw=true',
        description: "After graduating from UVU in 2013 with a B.S. in Biotechnology, I worked as a Research Associate for 7 yrs in medical diagnostics. I was introduced to software development during that time and decide to enroll in the University of Utah coding bootcamp.",
        repo: 'https://github.com/E-Huynh',
        linkedin: 'https://www.linkedin.com/in/erik-huynh-228321196',
        link: '',
        tech: ['UtahValleyUniversity', 'UofU', 'Bootcamp', "Bachelor's Degree"],
        type: 'bio'
    },
    {
        id: 'note-taker',
        title: 'Note Taker',
        image: 'https://github.com/E-Huynh/portfolio-gram/blob/master/src/assets/note_taker.png?raw=true',
        description: 'Application that allows users to store, view and delete notes.',
        repo: 'https://github.com/E-Huynh/note_taker',
        link: 'https://secure-waters-63965.herokuapp.com/',
        tech: ['Bootstrap', 'FileSystem', 'Path', 'Jquery'],
        type: 'project'
    },
    {
        id: 'team-profile-generator',
        title: 'Team Profile Generator',
        image: 'https://github.com/E-Huynh/portfolio-gram/blob/master/src/assets/Team_Profile_Generator.png?raw=true',
        description: 'Application that use CLI to input employee information. HTML file automatically generated display team info.',
        repo: 'https://github.com/E-Huynh/Team_Profile_Generator',
        link: '',
        tech: ['Bulma', 'Node.js', 'FileSystem', 'Inquirer'],
        type: 'project'
    },
    {
        id: 'github-pdf-generator',
        title: 'Github PDF Generator',
        image: 'https://github.com/E-Huynh/portfolio-gram/blob/master/src/assets/github_pdf.png?raw=true',
        description: 'Application scrapes github API by username search to generate a PDF resume.',
        repo: 'https://github.com/E-Huynh/github-pdf',
        link: '',
        tech: ['Axios', 'Puppeteer', 'Inquirer'],
        type: 'project'
    },
    {
        id: 'personal',
        title: 'Hobbies and Interests',
        image: 'https://e-huynh.github.io/updated_portfolio/assets/About_me.JPG',
        description: "When my schedule slows down, I enjoy many different hobbies including: fishing, painting miniatures, watching the NHL, and traveling to new places. During my recent travels, I had to opportunity to stop a Crater Lake National Park, Redwood National Forest, and Portland, OR. Portland was where I caught the largest fish of my life! A 6' 250 lbs sturgeon from the Columbia River.",
        repo: 'https://github.com/E-Huynh',
        linkedin: 'https://www.linkedin.com/in/erik-huynh-228321196',
        link: '',
        tech: ['UtahValleyUniversity', 'UofU', 'Bootcamp', "Bachelor's Degree"],
        type: 'bio'
    },
    {
        id: 'fast-hikes',
        title: 'Fast Hikes',
        image: 'https://github.com/E-Huynh/portfolio-gram/blob/master/src/assets/Fast_hikes.png?raw=true',
        description: 'Application takes in driving duration and hike length from current location and returns hikes nearby that meet the search criteria.',
        repo: 'https://github.com/E-Huynh/FastHikes',
        link: 'https://e-huynh.github.io/FastHikes/',
        tech: ['CssGrid', 'Flexbox', 'Jquery', 'HikingProjectAPI', 'GoogleDistanceAPI'],
        type: 'project'
    },
    {
        id: 'weather-dashboard',
        title: 'Weather Dashboard',
        image: 'https://github.com/E-Huynh/portfolio-gram/blob/master/src/assets/weather_dashboard.png?raw=true',
        description: 'Be prepared for whatever the weather throws at you. Allows the user to search for the current and 5-day forecast of any city.',
        repo: 'https://github.com/E-Huynh/weather_dashboard',
        link: 'https://e-huynh.github.io/weather_dashboard/index.html',
        tech: ['CssGrid', 'Flexbox', 'LocalStorage', 'Moment.js', 'OpenWeatherAPI'],
        type: 'project'
    },
    {
        id: 'work-day-scheduler',
        title: 'Work Day Scheduler',
        image: 'https://github.com/E-Huynh/portfolio-gram/blob/master/src/assets/work_day_planner.png?raw=true',
        description: 'Track your daily schedule. Users can input their schedule by hour to plan out their day.',
        repo: 'https://github.com/E-Huynh/work-day-scheduler',
        link: 'https://e-huynh.github.io/work-day-scheduler/',
        tech: ['HTML', 'CSS', 'Jquery'],
        type: 'project'
    },
    {
        id: 'quiz-game',
        title: 'Quiz Game',
        image: 'https://github.com/E-Huynh/portfolio-gram/blob/master/src/assets/quiz_game.png?raw=true',
        description: 'Test your knowledge with this programming related interactice quiz with timer and a highscore tracker.',
        repo: 'https://github.com/E-Huynh/quiz_game',
        link: 'https://e-huynh.github.io/quiz_game/quiz_game.html',
        tech: ['DOM', 'Javascript', 'CSS'],
        type: 'project'
    },
    {
        id: 'password-generator',
        title: 'Password Generator',
        image: 'https://github.com/E-Huynh/portfolio-gram/blob/master/src/assets/password_generator.png?raw=true',
        description: 'Quickly generate passwords with user specified inputs of character type and length.',
        repo: 'https://github.com/E-Huynh/Password_Generator',
        link: 'https://e-huynh.github.io/Password_Generator/',
        tech: ['Bootstrap', 'Javascript'],
        type: 'project'
    },
    {
        id: 'rgb-game',
        title: 'RGB Game',
        image: 'https://github.com/E-Huynh/portfolio-gram/blob/master/src/assets/rgb_game.png?raw=true',
        description: 'Test your knowledge of RGB color values by choosing the right tile. Easy and hard modes available.',
        repo: 'https://github.com/E-Huynh/RGB_game',
        link: 'https://e-huynh.github.io/RGB_game/',
        tech: ['HTML', 'CSS', 'Jquery'],
        type: 'project'
    },
]